<div class="grid-x align-middle align-justify">
    <h2 class="cell shrink _sansSerif _primary" [i18nKey]="titleLabelKey"></h2>
<button (click)="onSave()" [disabled]="saveDisabled" class="button _iconRight cell shrink">
    <span [i18nKey]="'common.action.save'"></span>
    <i class="fas fa-save"></i>
</button>
</div>

<kiwi-spacer [size]="16"></kiwi-spacer>

<div class="alertMessage">
    <i class="fas fa-exclamation-triangle alertMessage-icon"></i>
    <span class="alertMessage-text"[i18nKey]="'parameters.disabled.session.parameters.explanation'"></span>
</div>
